import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import Select from "react-select";
import userBackground from "assets/img/bg5.jpg";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button,
  CardAuthor,
  CardSocials,
  ImageUpload
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";

///  <NUEVO PARA NOTIFICAR SIM>
import SweetAlert from "react-bootstrap-sweetalert";
///  </NUEVO PARA NOTIFICAR SIM>
import Iframe from "react-iframe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLastfmSquare, faLess } from "@fortawesome/free-brands-svg-icons";
import moment from "moment";
import "moment/locale/es";
// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const CONFIRMAR_SIM = "SIM";
const NEW_PHOTO = "new-photo";
class Tickets extends React.Component {
  constructor(props) {
    super(props);

    // console.log("this.props",this.props.match.params);
    let ticket_id = parseInt(this.props.match.params.ticket);
    this.state = {
      servicesSize: 3,
      ticketsColsSize: {
        xs: 12,
        md: 6
      },
      ticket_id: ticket_id,
      showDescription: true,
      newMessage: ""
    };
    this.redirectTo = this.redirectTo.bind(this);
    this.isAgent = this.isAgent.bind(this);
    this.cancelAddPhoto = this.cancelAddPhoto.bind(this);
    this.toggleImageSize = this.toggleImageSize.bind(this);
    this.isReadyToSendMessage = this.isReadyToSendMessage.bind(this);
  }
  componentDidMount() {
    this.props.get_support_ticket(this.state.ticket_id);
    this.props.get_departments();
  }
  toggleImageSize(message_id) {
    if (this.state.bigImage === message_id) {
      this.setState({
        bigImage: null
      });
    } else {
      this.setState({
        bigImage: message_id
      });
    }
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      confirmICC: "",
      ICC: "",
      confirmingDelivery: "",
      fieldStates: []
    });
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case CONFIRMAR_SIM:
        this.deliverySIMConfirmation();
        break;
      default:;
    }
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case CONFIRMAR_SIM:
        return this.createConfirmSIMDeliveryPopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  buildTicketDepartment(department) {
    // console.log("department", department);
    let department_id = parseInt(department.id);
    let department_name = department.name;
    let department_class = "";
    let department_icon = "";
    let style = {
      background: "#CCC",
      color: "#000",
      fontWeight: "500",
      borderRadius: "3px",
      padding: "5px 10px",
      fontSize: "10px"
    };
    switch (department_id) {
      case 109: // Facturacion
        department_class = "facturacion";
        department_icon = "business_money-coins";
        break;
      case 120: // Marketing
        department_class = "marketing";
        department_icon = "shopping_bag-16";
        break;
      case 307: // Programación
        department_class = "programacion";
        department_icon = "education_glasses";
        break;
      case 108: // Técnico
        department_class = "tecnico";
        department_icon = "objects_support-17";
        break;
      case 308: // Redes
        department_class = "redes";
        department_icon = "media-2_sound-wave";
        break;
      case 306: // Sistemas
        department_class = "sistemas";
        department_icon = "location_world";
        break;
      default:
        break;
    }

    return (
      <span className={"ticket-department dep-" + department_class}>
        <i className={"ticket-department-icon now-ui-icons " + department_icon} />
        {department_name}
      </span>
    );
  }
  buildTicketDepartmentOptions(departments) {
    // console.log("department", department);
    if (!departments) return [];
    let result = [];
    departments.map(department => {
      department.name = department.label;
      department.id = department.value;
      let department_id = parseInt(department.id);
      let department_name = department.name;
      let department_class = "";
      let department_icon = "";
      switch (department_id) {
        case 109: // Facturacion
          department_class = "facturacion";
          department_icon = "business_money-coins";
          break;
        case 120: // Marketing
          department_class = "marketing";
          department_icon = "shopping_bag-16";
          break;
        case 307: // Programación
          department_class = "programacion";
          department_icon = "education_glasses";
          break;
        case 108: // Técnico
          department_class = "tecnico";
          department_icon = "objects_support-17";
          break;
        case 308: // Redes
          department_class = "redes";
          department_icon = "media-2_sound-wave";
          break;
        case 306: // Sistemas
          department_class = "sistemas";
          department_icon = "location_world";
          break;
        default:
          break;
      }
      result.push({
        label: (
          <span className={"ticket-department dep-" + department_class}>
            <i className={"ticket-department-icon now-ui-icons " + department_icon} />
            {department_name}
          </span>
        ),
        value: department_id
      });
    });
    return result;
  }
  buildTicketPriority(priority) {
    // console.log("state", state);
    let priority_id = parseInt(priority.id);
    let priority_name = priority.name;
    let priority_class = "";
    switch (priority_id) {
      case 110: // Baja
        priority_class = "baja";
        break;
      case 111: // Media
        priority_class = "media";
        break;
      case 112: // Alta
        priority_class = "alta";
        break;
      default:
        break;
    }

    return (
      <span className={"priority" + " prio-" + priority_class}>
        {priority_name}
      </span>
    );
  }
  buildTicketState(state) {
    // console.log("state", state);
    let state_id = parseInt(state.id);
    let state_name = state.name;
    let state_class = "";
    switch (state_id) {
      case 117: // Abierto
        state_class = "abierto";
        break;
      case 118: // Cerrado
        state_class = "cerrado";
        break;
      case 300: // Esperando respuesta
        state_class = "esperando";
        break;
      case 299: // Pendiente
        state_class = "pendiente";
        break;
      default:
        break;
    }
    let result = [];
    result.push(
      <div key={"circle"} className={"circle-state state-" + state_class}></div>
    );
    result.push(
      <span key={"state"} className={"ticket-state state-" + state_class}>
        {state_name}
      </span>
    );

    return result;
  }
  isTicketClosed(state) {
    if (parseInt(state.id) === 118) return "ticket-closed";
  }
  buildTicketCustomer(customer) {
    let result = null;

    result = (
      <div className="ticket-customer">
        <img className="ticket-customer-picture" src={customer.picture} alt={customer.name} />
        <span className="ticket-customer-name">{customer.name}</span>
      </div>
    );

    return result;
  }
  isReadyToSendMessage() {
    let result = false;
    if (this.state.newMessage && this.state.newMessage.length > 0 ||
      this.state.newPhoto) result = true;
    return result;
  }
  sendMessage() {
    if (this.isReadyToSendMessage()) {
      let newMessage = {
        text: this.state.newMessage
      };
      if (this.state.newPhoto) {
        newMessage.data = [
          {
            type: "photo",
            data: this.state.newPhoto.photo
          }
        ];
      }
      this.props.sendTicketMessage(this.state.ticket_id, newMessage);
      this.setState({
        newMessage: "",
        showNewPhotoBox: false,
        newPhoto: null
      });
    }
  }
  cancelAddPhoto() {
    this.setState({
      showNewPhotoBox: false,
      newPhoto: null
    });
  }
  setUploadedPhoto(image, identifier) {
    let currentUser = this.props.state.user;
    let currentVisitPhoto = {
      photo: image
    };
    let newPhoto = null;
    // if (identifier === NEW_PHOTO) {
      if (this.state.newPhoto) {
        newPhoto = this.state.newPhoto;
        newPhoto.photo = image;
        this.setState({ newPhoto: newPhoto });
      } else {
        this.setState({ newPhoto: { photo: image } });
      }
    // } else {
    //   if (!homeVisitPhotos) homeVisitPhotos = [];
    //   if (identifier in homeVisitPhotos) {
    //     currentVisitPhoto = homeVisitPhotos[identifier];
    //     currentVisitPhoto.photo = image;
    //   }
    //   homeVisitPhotos[identifier] = currentVisitPhoto;
    //   let homeVisit = this.state.homeVisit;
    //   homeVisit.visit_photos = homeVisitPhotos;
    //   this.setState({ homeVisit: homeVisit });
    // }
  }
  buildMessages(messages, customerID) {
    if (customerID) customerID = parseInt(customerID);
    let isOwnTicket = parseInt(this.props.state.user.uid) === customerID;
    let result = [];
    if (!messages || messages === undefined || messages === null) {
      return (
        <Row key="mensaje-cargando">
          <Col xs={12} className="ml-auto text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando mensajes...
          </Col>
        </Row>
      );
    } else {
      // console.log("ticket messages", messages);
      if (messages.length > 0) {
        messages = messages.map((message, key) => {
          let hasData = false;
          let isPhotoMessage = false;
          let photoData = "";
          let photoWrapper = null;
          if (message.data) {
            hasData = true;
            message.data.map(currentData => {
              switch (currentData.type) {
                case "photo":
                  isPhotoMessage = true;
                  photoData = currentData.data;
                  photoWrapper = (
                    <div 
                    className="photo-wrapper"
                    onClick={ () => {
                      this.toggleImageSize(message.id);
                    }}
                    >
                      <img src={photoData} alt="Imagen del comentario" />
                    </div>
                  );
                  break;
                default:
                  break;
              }
            });
          }
          if (message.text.includes("####LOG####")) {
            let message_text = message.text;
            message_text = message.text.replace("####LOG####", "").trim();
            return (
              <Row key={"mensaje-log-" + key}>
                <Col xs={12} className="ml-auto text-center">
                  <div className="log-message" dangerouslySetInnerHTML={{ __html: message_text }} />
                  <span className="ticket-summup-date">
                    {moment(message.date).fromNow()}
                  </span>
                </Col>
              </Row>
            );
          } else {
            let sending_message = "";
            let is_sending = false;
            let direction = message.direction;
            if (message.state && message.state.id) {
              if (message.state.id === 666) {
                sending_message = "sending";
                is_sending = true;
                message.is_current_user = true;
                direction = "right";
              }
            }

            // let direction = message.is_customer ? "left" : "right";
            // if (isOwnTicket) message.is_customer ? "right" : "left";
            // // console.log("message", message);
            let author_picture = (
              <span className="author-picture">
                <img className="ticket-customer-picture" src={message.author.picture} alt={message.author.name} />
              </span>
            );
            let current_user = message.is_current_user ? "current-user" : "";
            let message_text = "";
            try {
              let message_json = JSON.parse(message.text);
              message_text = message_json.text;
            } catch (error) {
              message_text = message.text;
            }
            let messageSize = {
              xs: 12,
              md: 8
            };
            let messagePhotoClass = "";
            if (isPhotoMessage) {
              messageSize = {
                xs: 6,
                sm: 5,
                md: 4,
                lg: 4
              };
              messagePhotoClass = "photo-message";
              if (this.state.bigImage === message.id) {
                messageSize = {
                  xs: 12,
                  sm: 12,
                  md: 10,
                  lg: 8,
                  xl: 8
                };
              }
            }
            let direction_right = direction === "right";
            return (
              <Row className="message-wrapper" key={message.id}>
                <Col {...messageSize} className={direction_right ? "ml-auto" : "mr-auto"}>
                  <div className={"message " + "message-" + direction + " " + current_user + " " + sending_message + " " + messagePhotoClass}>
                    <div className={"message-author text-" + direction}>
                      {!direction_right && author_picture}
                      <span className="author-name">{message.author.name}</span>
                      {direction_right && author_picture}
                    </div>
                    <div className={"message-bubble"}>
                      {photoWrapper}
                      <span className="message-text">
                        <div dangerouslySetInnerHTML={{ __html: message_text }} />
                      </span>
                      <div className={"text-left"}>
                        <span className="ticket-summup-date">
                          {is_sending ? <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Enviando</span> : moment(message.date).fromNow()}
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            );
          }
        });
      } else {
        messages = (
          <Row>
            <Col xs={12} className="ml-auto text-center">
              <span className="log-message">Todavía no hay mensajes</span>
            </Col>
          </Row>
        );
      }
      result.push(messages);
      result.push(
        <Row key="formulario-nuevo-mensaje">
          <Card>
            <CardBody>
              <Col size={12} className="nuevo-mensaje">
                <Row className="text-right">
                  {this.state.showNewPhotoBox ? 
                    <Col xs={12} md={3} lg={2} className="ml-auto">
                      <Card className="card-testimonial" color="warning">
                        <CardHeader className="card-header-avatar home-visit">
                          {/* <a href="#pablo">
                            <img className="img img-raised" src={avatar} alt="..." />
                          </a> */}
                          <ImageUpload 
                            getImage={this.setUploadedPhoto.bind(this)} 
                            existingImage={this.state.newPhoto ? this.state.newPhoto.photo : null}
                            imageIdentifier={NEW_PHOTO}
                            hideDeleteButton
                          />
                          <Button
                            // icon
                            // round
                            block
                            key={"cancelAddPhotoButton"}
                            color="danger"
                            onClick={() => {
                              this.cancelAddPhoto();
                            }}
                            // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                          >Cancelar</Button>
                        </CardHeader>
                      </Card>
                    </Col> : <Col xs={12} className="text-right">
                      <Button
                          icon
                          round
                          block
                          key={"createPhotoButton"}
                          color="warning"
                          className="txt-black ml-auto"
                          onClick={() => {
                            this.setState({ showNewPhotoBox: true });
                          }}
                          leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingHomeVisitPhoto ? "arrows-1_refresh-69 spin reposition-spin" : "media-1_album")}
                        />
                      </Col>}
                </Row>
                <FormGroup>
                </FormGroup>
                <div className="enviar-mensaje">
                  <Button
                    block
                    color={"primary"}
                    round 
                    icon
                    size="lg"
                    disabled={!this.isReadyToSendMessage()}
                    onClick={() => {
                      this.sendMessage();
                      // if (isOpened) {
                      //   this.props.closeTicket(ticket.id);
                      // } else {
                      //   this.props.openTicket(ticket.id);
                      // }
                    }}
                  >
                    <i className="now-ui-icons ui-1_send" />
                  </Button>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Row>
      );
      return result;
    }
  }
  isAgent(ticket) {
    if (!ticket) return false;
    if (!ticket.agent) return false;
    if (this.props.state.user) {
      let user = this.props.state.user;
      if (parseInt(user.uid) === parseInt(ticket.agent.id)) return true;
    }
    return false;
  }
  buildTicketAgent(agent) {
    let result = null;

    if (!agent || agent === null) {
      result = (
        <Col className="text-center">
          <div style={{padding:"10px"}}>Sin asignar</div>
        </Col>
      );
    } else {
      result = (
        <div className="ticket-customer">
          <img className="ticket-customer-picture" src={agent.picture} alt={agent.name} />
          <span className="ticket-customer-name">{agent.name}</span>
        </div>
      );
    }

    return result;
  }

  render() {
    // console.log("######## PARAMS TOOLS ##########");
    // console.log(this.props.match.params);
    // console.log("_isToolSelected", _isToolSelected);
    // console.log("usuario actual", this.props.state.user);
    let content = null;
    let tickets = this.props.state.tickets;
    let headerContent = null;
    
    if (tickets && this.state.ticket_id in tickets) {
      let ticket = tickets[this.state.ticket_id];
      let customer = ticket.customer;
      let userAvatar = customer.picture;
      let description = ticket.description;
      // let summup = ticket.description.replace(/<\/?[^>]+(>|$)/g, "");
      let summup = ticket.title;
      if (summup && summup.length > 100) summup.substring(0, 100) + "[...]";
      let messages = this.buildMessages(ticket.comments, ticket.customer.id);
      let isAgent = this.isAgent(ticket);
      let assignButtonText = "";
      if (!isAgent) {
        if (!this.props.state.assigningTicket) {
          assignButtonText = (
            <span><i className="now-ui-icons business_badge" /> Asignarme ticket</span>
          );
        } else {
          assignButtonText = (
            <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Asignando</span>
          );
        }
      } else {
        if (!this.props.state.assigningTicket) {
          assignButtonText = (
            <span><i className="now-ui-icons business_badge" /> Abandonar ticket</span>
          );
        } else {
          assignButtonText = (
            <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Abandonando</span>
          );
        }
      }
      let isOpened = parseInt(ticket.state.id) !== 118;
      let openTicketText = "";
      if (isOpened) {
        if (!this.props.state.openingTicket) {
          openTicketText = (
            <span><i className="now-ui-icons ui-1_check" /> Cerrar ticket</span>
          );
        } else {
          openTicketText = (
            <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cerrando</span>
          );
        }
      } else {
        if (!this.props.state.openingTicket) {
          openTicketText = (
            <span><i className="now-ui-icons ui-1_lock-circle-open" /> Abrir ticket</span>
          );
        } else {
          openTicketText = (
            <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Abriendo</span>
          );
        }
      }
      // console.log("Ticket cargado", ticket);
      content = (
        <Row>
          <Col xs={12} md={2} className="ticket-customer">
            <Card className="card-user">
              <div className="image">
                <img src={userBackground} alt="..." />
              </div>
              <CardBody>
                <CardAuthor
                  avatar={userAvatar}
                  avatarAlt={customer.name}
                  title={customer.name}
                  link={"/clientes/fichas/" + customer.id}
                  // description="michael23"
                />
                <p className="ticket-description description text-center">
                  {summup}
                </p>
                <span className="ticket-summup-date">{moment(ticket.date).fromNow()}</span>
              </CardBody>
              <hr />
              <Row className="ticket-links">
                <Col 
                  xs={6} 
                  className="text-center link"
                  onClick={() => this.redirectTo("/clientes/fichas/" + customer.id)}
                >
                    <i className="now-ui-icons users_circle-08" />
                    <span className="texto-link">Ficha</span>
                </Col>
                <Col 
                  xs={6} 
                  className="text-center link"
                  onClick={() => this.setState({ showDescription: !this.state.showDescription })}
                >
                    <i className="now-ui-icons text_align-left" />
                    <span className="texto-link">{this.state.showDescription ? "Ocultar" : "Detalles"}</span>
                </Col>
              </Row>
            </Card>
            <Card>
              <CardBody>
                <span className="category">Cambiar departamento</span>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Cambiar departamento"
                  name="selectedDepartment"
                  value={this.state.selectedDepartment ? this.state.selectedDepartment : this.buildTicketDepartmentOptions([{label: ticket.department.name, value: ticket.department.id}])[0]}
                  options={this.buildTicketDepartmentOptions(this.props.state.departments)}
                  noOptionsMessage={() => <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando departamentos</span>}
                  onChange={value => {
                    this.setState({ selectedDepartment: value });
                    this.props.changeTicketDepartment(ticket.id, value.value);
                  }}
                />
              </CardBody>
            </Card>
            {ticket.agent && <Card>
              <CardBody>
                <CardTitle>Agente</CardTitle>
                {this.buildTicketAgent(ticket.agent)}
              </CardBody>
            </Card>}
            <Button
              block
              color={isAgent? "danger" : "primary"}
              // round 
              // icon 
              disabled={this.props.state.assigningTicket}
              onClick={() => {
                if (!isAgent) {
                  this.props.assignTicket(ticket.id);
                } else {
                  this.props.unassignTicket(ticket.id);
                }
              }}
            >
              {assignButtonText}
            </Button>
            <Button
              block
              color={isOpened ? "info" : "warning"}
              // round 
              // icon 
              disabled={this.props.state.openingTicket}
              onClick={() => {
                if (isOpened) {
                  this.props.closeTicket(ticket.id);
                } else {
                  this.props.openTicket(ticket.id);
                }
              }}
            >
              {openTicketText}
            </Button>
          </Col>
          <Col xs={12} md={10}>
            <Row>
            {this.state.showDescription && <Col xs={12}>
                <Card>
                  <CardBody>
                    <div dangerouslySetInnerHTML={{ __html: ticket.description }} />
                  </CardBody>
                </Card>
              </Col>}
              <Col xs={12} md={4} className="ml-auto mr-auto text-center">
                <Card>
                  <CardBody>
                    <CardTitle>
                      Mensajes
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
              <Col xs={12} className="ticket-messages">
                {messages}
              </Col>
            </Row>
          </Col>
        </Row>
      );
      let substate = this.buildTicketState(ticket.substate);
      if (substate) substate = (
        <span>
        {substate} <br />
        </span>
      );

      headerContent = (
        <Row className="ticket-summup ticket-header">
          <div className="ticket-priority">
            {this.buildTicketPriority(ticket.priority)}
          </div>
          <Col xs={12} className="text-center text-white">
            <h3 className="ticket-reference">
              #{ticket.reference}
            </h3>
            
          </Col>
          <Col {...this.state.ticketsColsSize} className="text-center">
            {this.buildTicketDepartment(ticket.department)}
          </Col>
          <Col {...this.state.ticketsColsSize} className="text-center">
            {this.buildTicketState(ticket.state)}<br />
            {substate}
            <span className="ticket-summup-date">{moment(ticket.last_comment).fromNow()}</span>
          </Col>
        </Row>
      );
      // if (Object.keys(tickets).length > 0) {
      //   content = this.buildTickets(tickets);
      // }
    } else {
      content = (
        <Row>
          <Col xs={12}>
            <Card className="text-center text-black" color="primary">
              <CardBody>
                <div className="text-center">
                  <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando ticket...
                </div>
                <br />
              </CardBody>
            </Card>
          </Col>
        </Row>
      );
    }
    return (
      <div>
        <PanelHeader
          // size="sm"
          content={
            <div>
              {/* <h6 style={dashboardOrdersTitleStyle}>Herramientas</h6> */}
              {headerContent}
            </div>
          }
        />
        <div className="content">{content}</div>
      </div>
    );
  }
}

export default Tickets;



// WEBPACK FOOTER //
// ./src/views/Tickets/ViewTicket.jsx